import React from 'react';
import { t } from '../../helpers/componentHelper';
import Info from 'components/Info/Info';

import './LockPick.scss';

type LockPickProps = {
  /**
   * Lock-tier leg hit rate as a 0..1 fraction, computed server-side over
   * the rolling 42-day window (see backend /api/v1/picks/lock-stats).
   * Null/undefined renders a hyphen placeholder so the dial still mounts
   * cleanly while the data is loading or when no legs have resolved yet.
   */
  successRate?: number | null;
  showInfo?: boolean;
};

const formatRate = (rate: number | null | undefined): string => {
  if (rate === null || rate === undefined || !Number.isFinite(rate)) {
    return '—';
  }
  return `${Math.round(rate * 100)}%`;
};

function LockPick({ successRate, showInfo }: LockPickProps) {
  const infoHeader = <span>{`${t('pages.home.lockpickHeader')}`}</span>;

  const infoBody = (
    <div>
      <div className={'info__text'}>{`${t('pages.home.lockpickDesc')}`}</div>
    </div>
  );

  return (
    <div className={'lockPick'}>
      {showInfo && (
        <div className={'lockPick__header'}>
          <Info
            header={infoHeader}
            body={infoBody}
            iconHoverElement={
              <span className={'lockPick__lock--logo'}>
                {`${t('pages.home.lockpick')}`} &#8482;
              </span>
            }
          />
        </div>
      )}
      <div className={'lockPick__body'}>
        <div className={'lockPick__body--dial'}>
          <div className={'lockPick__body--dial-a'}></div>
          <div className={'lockPick__body--dial-b'}></div>
          <div
            className={'lockPick__body--dial-c'}
            style={{ transform: `rotate(${successRate ? successRate * 180 : 0}deg)` }}
          ></div>
          <div className={'lockPick__body--dial-data'}>
            <h1 id="percent">{formatRate(successRate)}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LockPick;
